import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [adminUser, setAdminUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Load Client Session
    const savedClient = localStorage.getItem('bpas_client_session') || sessionStorage.getItem('bpas_client_session');
    if (savedClient) {
      try {
        const parsed = JSON.parse(savedClient);
        if (!parsed.expiry || Date.now() < parsed.expiry) {
          setUser(parsed.client);
        }
      } catch (e) { console.error(e); }
    }

    // Load Admin Session
    const savedAdmin = localStorage.getItem('bpas_admin_session') || sessionStorage.getItem('bpas_admin_session');
    if (savedAdmin) {
      try {
        const parsed = JSON.parse(savedAdmin);
        if (!parsed.expiry || Date.now() < parsed.expiry) {
          setAdminUser(parsed.user);
        }
      } catch (e) { console.error(e); }
    }

    setLoading(false);
  }, []);

  const login = (clientData, rememberMe) => {
    const expiry = rememberMe ? Date.now() + 7 * 24 * 60 * 60 * 1000 : null;
    const sessionData = { client: clientData, expiry };
    if (rememberMe) localStorage.setItem('bpas_client_session', JSON.stringify(sessionData));
    else sessionStorage.setItem('bpas_client_session', JSON.stringify(sessionData));
    setUser(clientData);
  };

  const logout = () => {
    localStorage.removeItem('bpas_client_session');
    sessionStorage.removeItem('bpas_client_session');
    setUser(null);
  };

  const adminLogin = (adminData, rememberMe) => {
    const expiry = rememberMe ? Date.now() + 7 * 24 * 60 * 60 * 1000 : null;
    const sessionData = { user: adminData, expiry };
    if (rememberMe) localStorage.setItem('bpas_admin_session', JSON.stringify(sessionData));
    else sessionStorage.setItem('bpas_admin_session', JSON.stringify(sessionData));
    setAdminUser(adminData);
  };

  const adminLogout = () => {
    localStorage.removeItem('bpas_admin_session');
    sessionStorage.removeItem('bpas_admin_session');
    setAdminUser(null);
  };

  return (
    <AuthContext.Provider value={{ 
      user, adminUser, loading, 
      login, logout, 
      adminLogin, adminLogout 
    }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);